<template>
    <div :class="['parameter', {'is-mobile': isMobile}]">
        <h3 class="title">{{$route.params.lang === 'EN' ? 'Specification' : '参数配置'}}</h3>
        <ul class="params clearfix" v-if="isMobile">
            <template  v-for="(j, index) in params">
                <li v-if="index !== 3" :key="index">
                    <img v-if="j.img" :src="j.img" alt="">
                    <h4 v-if="j.title">{{ j.title }}</h4>
                    <div v-for="(p, k) in j.detail" :key="(j.title || 'title') + k" class="params-item">
                        <template v-if="p[1] === null">
                            <h5>{{p[0]}}</h5>
                        </template>
                        <template v-else>
                            <span  v-html="p[0]"></span><span v-html="p[1]"></span>
                        </template>
                    </div>
                </li>
            </template>
            <li class="width-extra" slot="extra">
                <div :class="[{'params-box': index > 0}, {active: index === activeIndex}]" v-for="(item, index) in count" :key="index" @click="activeIndex === index ? activeIndex = 0 : activeIndex = index">
                    <img v-if="extraParam.img && index === 0" :src="extraParam.img" alt="">
                    <h4 v-if="extraParam.title && index === 0">{{ extraParam.title }}</h4>
                    <template  v-for="(p, k) in extraParam.detail">
                        <div v-if="index === 0 && k < item || index > 0 && k < item && k >= count[index - 1]" :key="(extraParam.title || 'title') + k" class="params-item">
                        <template v-if="p[1] === null">
                            <h5>{{p[0]}}</h5>
                        </template>
                        <template v-else>
                            <span  v-html="p[0]"></span><span v-html="p[1]"></span>
                        </template>
                    </div>
                    </template>
                </div>
            </li>
            <li></li>
        </ul>
        <ul class="params vertical clearfix" v-else>
            <li class="clearfix" v-for="j in params" :key="j.title+`${Math.random()}`">
                <div class="pic">
                    <img v-if="j.img" :src="j.img" alt="" :style="{width: j.width+'px', height: 'auto'}">
                    <h4 v-if="j.title">{{ j.title }}</h4>
                </div>
               <div :class="['params-wrap', {'height-extra': index > 2}]" v-for="(item, index) in j.grid" :key="item">
                   <template v-for="(p, k) in j.detail">
                    <div v-if="index > 0 && k < item && k >= j.grid[index - 1] || index === 0 && k < item"  :key="j.title + k" class="params-item">
                        <template v-if="p[1] === null">
                            <h5>{{p[0]}}</h5>
                        </template>
                        <template v-else>
                            <span class="name" v-html="p[0]"></span><span>：</span><span v-html="p[1]"></span>
                        </template>
                    </div>
                </template>
               </div>
            </li>
        </ul>
    </div>
</template>

<script>
import { isMobile } from '@/js/utils';

export default {
    name: 'parameter',
    data() {
        return {
            isMobile: false,
            activeIndex: 0,
            extraParam: this.params[this.params.length - 1],
            count: [5, 11, 17, 25, 29],
        }
    },
    methods: {
        resize() {
            this.isMobile = window.innerWidth <= 600 || isMobile()
        }
    },
    props: {
        params: {
            type: Array
        }
    },
    watch: {
        params: {
            deep: true,
            handler(val) {
                this.params.forEach(item => {
                    if(!item.grid) {
                        this.$set(item, 'grid', [5, 10, 15])
                    }
                })
                this.extraParam = this.params[this.params.length - 1]
            }
        },
    },
    mounted() {
        this.params.forEach(item => {
            if(!item.grid) {
                this.$set(item, 'grid', [5, 10, 15])
            }
        })
        this.isMobile = window.innerWidth <= 600 || isMobile()
        window.addEventListener('resize', this.resize)
    },
    beforeDestroy() {
        window.removeEventListener('resize',this.resize)
    }
}
</script>
<style lang="scss">
    .parameter {
        background: #ffffff;
        color: #000000;
        box-sizing: border-box;
        text-align: left;
        padding-top: 2% !important;
        min-height: 100vh;
        padding-bottom: 40px;        
        &:not(.is-mobile) {
            min-width: 1200px;
        }
        .title {
            line-height: 6vw !important;
            text-align: center;
            margin-bottom: 4vw;
        }
        .params {            
            margin: 0 auto;
            width: 1110px;
            position: relative;
        }
        li {
            width: 340px;
            float: left;
            &:nth-child(-n+2)::after {
                content: "";
                position: absolute;
                height: calc(100% - 200px);
                width: 1px;
                background: #E9E9E9;
                top: 180px;
            }
            &:nth-child(1)::after{
                right: 750px;
            }
            &:nth-child(2)::after{
                right: 380px;
            }
        }
        h4 {
            font-size: 24px;
            font-weight: 500;
            line-height: 70px;
            margin-bottom: 10px;
        }
        img {
            height: 95px;
        }
        .params-item {
            font-size: 0
        }
        h5 {
            display: block;
            width:260px;
            height:30px;
            text-align: center;
            background:rgba(233,233,233,1);
            font-size:14px;
            font-family:'PingFangSC-Medium', 'PingFang SC', 'Microsoft Yahei';
            font-weight:500;
            color:rgba(0,0,0,0.8);
            line-height:30px;
            margin-bottom: 8px;

        }
        span {
            display: inline-block;
            font-size: 14px;
            vertical-align: top;
            color: rgba(0,0,0,0.8);
            line-height: 26px;
        }
        span:nth-child(1) {
            width: 135px;
        }
        span:nth-child(2) {
            width: 190px
        }
        @media screen and (max-width: 1440px){
            .title {
                line-height: 100px !important;
                margin-bottom: 2vw;
            }
            span {
                line-height: 22px;
            }
        }
        .params.vertical {
            width: 1200px;
            padding-bottom: 94px;
            li {
                width: 100%;
                box-sizing: border-box;
                font-size: 0;
                &+li {
                    margin-top: 66px;
                }
                .pic {
                    float: left;
                    width: 175px;
                    text-align: center;
                    padding-right: 95px;
                }
                h4 {
                    line-height: 33px;
                    margin-top: 29px;
                }
                .params-wrap {
                    width: 300px;
                    position: relative;
                    display: inline-block;
                    vertical-align: top;
                }
                .height-extra {
                    margin-top: 20px
                }
                .params-item {
                    line-height: 34px;
                    span {
                        width: auto;
                        vertical-align: top;
                        white-space: nowrap;
                        &:nth-child(1) {
                            font-weight:500;
                        }
                        &:nth-child(2) {
                            padding-right: 3px;
                        }
                        &:nth-child(3) {
                            font-weight: 300
                        }
                        
                    }
                }
                &::after {
                    display: none;
                }
            }
        }
        &.is-mobile {
            background: #FAFAFA;
            height: auto;
            padding-bottom: 3rem;
            padding-top: 3rem!important;
            min-height: auto;
            max-height: auto;
            overflow: hidden;
            .title {                
                text-align: left;
                padding:0 1rem 0.75rem !important;
                line-height: 1!important;
                font-weight: 550;
            }
            h4 {
                font-size: 0.8rem;
            }
            h5 {
                margin-top: 0.4rem
            }
            span {
                font-size: 0.6rem;
                white-space: normal;
            }
            ul {
                white-space: nowrap;
                width: 100%;
                padding-right: 1px;
                overflow-x: auto;
                font-size: 0;
                display: flex;
            }
            li {
                width: auto;
                margin-left: 1rem;
                padding: 1.5rem 0.7rem;
                background: #ffffff;
                border: 1px solid #EAEAEA;
                float: none;
                span:nth-child(1) {
                    margin-right: 1rem;
                }
                &:nth-child(3) {
                    span:nth-child(1) {
                        width: 4rem;
                    }
                    span:nth-child(2) {
                        width: 9rem;
                    }
                }
                &:nth-last-child(1) {
                    width: 0;
                    border: 0;
                    background: transparent;
                    padding: 1px;
                }
                span:nth-child(1) {
                    width: 5.4rem
                }
                span:nth-child(2) {
                    width: 7rem;
                    // word-break: break-all
                    white-space: normal;
                }
                img {
                    height: 3.4rem;
                }
            }
            li::after {
                display: none
            }
        }
    }
@media screen and (min-width: 601px){
    .english .parameter .params li {
        &+li {
            margin-top: 40px;
        }
        
        .pic h4 {
            font-size: 20px;
        }
        .params-item{
 
            line-height: 26px;
            span {
                font-size: 12px;
            }
            span:nth-child(1) {
                font-weight: 550;
            }
            span:nth-child(3) {
                font-weight: 500;
            }
        }
    }
}
</style>